/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import {
	all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import api from '../../services/api';
import { Types } from '../ducks/daca';
import executeAction from './comum/executeAction';

import { DACA } from '../../constants/apiRoutes';

/** SAGAS */
function* asyncDacaBuscar(action) {
	yield executeAction(function* () {
		const { dacaId, callback } = action;

		const { data } = yield call(api.get, `/daca/buscar/${dacaId}`);

		yield put({
			type: Types.DACA_BUSCAR_POR_ID_REDUCER,
			daca: data,
		});

		callback();
	}, Types.DACA_BUSCAR_POR_ID);
}

function* asyncDacaSalvar(action) {
	yield executeAction(function* () {
		const { daca, callback } = action;

		const { data } = yield call(api.post, '/daca', daca);

		yield put({
			type: Types.DACA_SALVAR_REDUCER,
			daca: data,
		});

		callback(data);
	}, Types.DACA_SALVAR);
}

function* asyncDacaFiltro(action) {
	yield executeAction(function* () {
		const { filtro } = action;

		if (filtro.pagina < 0) filtro.pagina = 0;

		const { data } = yield call(api.post, DACA.FIND_FILTRO, filtro);

		yield put({
			type: Types.DACA_FILTRO_REDUCER,
			lista: data,
		});
	}, Types.DACA_FILTRO);
}

function* asyncDacaReset() {
	yield executeAction(function* () {
		yield put({
			type: Types.DACA_RESET_REDUCER,
		});
	}, Types.DACA_RESET);
}

function* takeDacaBuscar() {
	yield takeLatest(Types.DACA_BUSCAR_POR_ID, asyncDacaBuscar);
}

function* takeDacaCadastrar() {
	yield takeLatest(Types.DACA_SALVAR, asyncDacaSalvar);
}

function* takeDacaFiltro() {
	yield takeLatest(Types.DACA_FILTRO, asyncDacaFiltro);
}

function* takeDacaReset() {
	yield takeLatest(Types.DACA_RESET, asyncDacaReset);
}

export default function* root() {
	yield all([
		fork(takeDacaBuscar),
		fork(takeDacaCadastrar),
		fork(takeDacaFiltro),
		fork(takeDacaReset),
	]);
}
